import {
  GET_UPDATE_INVOICE_CONFIG_SUCCESS,
  GET_UPDATE_INVOICE_CONFIG_FAILED,
  RESET_GET_UPDATE_INVOICE_CONFIG,
  LOADING_GET_UPDATE_INVOICE_CONFIG,
  NETWORK_ERROR_GET_UPDATE_INVOICE_CONFIG,
} from "../types/index";
import { invoiceServices } from "../../config/axios";

const resetgetUpdateInvoicesCofig = () => {
  return { type: RESET_GET_UPDATE_INVOICE_CONFIG };
};

const getUpdateInvoicesCofig = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GET_UPDATE_INVOICE_CONFIG });
  await invoiceServices
    .post("updateInvoiceConfig", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.status) {
        case 200:
          dispatch(getUpdateInvoiceConfigsuccess(res.data));
          break;
        default:
          dispatch(getUpdateInvoiceConfigFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GET_UPDATE_INVOICE_CONFIG,
        payload: err,
      });
    });
};
function getUpdateInvoiceConfigsuccess(data) {
  return {
    type: GET_UPDATE_INVOICE_CONFIG_SUCCESS,
    payload: data,
  };
}
function getUpdateInvoiceConfigFailed(data) {
  return {
    type: GET_UPDATE_INVOICE_CONFIG_FAILED,
    payload: data,
  };
}

export { resetgetUpdateInvoicesCofig, getUpdateInvoicesCofig };
